/**
 * 复制文本到剪贴板
 * 支持现代浏览器的 Clipboard API 和旧浏览器的 textarea 备用方案
 */
export async function copyToClipboard(text: string): Promise<boolean> {
  // 首先尝试使用现代 Clipboard API
  if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (err) {
      console.error('Clipboard API 失败，尝试备用方案:', err);
      // 如果 Clipboard API 失败，继续尝试备用方案
    }
  }

  // 备用方案：使用 textarea 和 execCommand
  try {
    const textarea = document.createElement('textarea');
    // 设置必要的样式以确保在移动设备上工作
    // 关键：使用 position: absolute 和很小的视口外位置来避免触发键盘
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    textarea.style.left = '-9999px';
    textarea.style.width = '2em';
    textarea.style.height = '2em';
    textarea.style.padding = '0';
    textarea.style.border = 'none';
    textarea.style.outline = 'none';
    textarea.style.boxShadow = 'none';
    textarea.style.background = 'transparent';
    textarea.style.opacity = '0';
    textarea.style.pointerEvents = 'none';
    textarea.style.userSelect = 'text';
    textarea.value = text;

    document.body.appendChild(textarea);

    // 不直接 focus，改为使用 select
    const range = document.createRange();
    range.selectNodeContents(textarea);
    const sel = window.getSelection();
    if (sel) {
      sel.removeAllRanges();
      sel.addRange(range);
    }

    textarea.select();

    const successful = document.execCommand('copy');
    document.body.removeChild(textarea);

    return successful;
  } catch (err) {
    console.error('备用复制方案失败:', err);
    return false;
  }
}
